<template>
  <div>
    <div class="g-nav">
      <div class="n-nav">
        <div class="notice" v-if="noticeType">
          <div @click.prevent="hrefUrl" class="noticeContent">
            <p>
              服务通知：国庆期间，官网正常下单，排单生产延迟至10月8日，带来不便敬请谅解！客服照常服务，热线：13421832556、0752-5283248（刘工），祝新老客户国庆快乐！
            </p>
            <img
              src="./close.svg"
              class="closeNotice"
              @click.stop="closeNotice"
            />
          </div>
        </div>
        <div style="position: relative;" class="n-main-box">
          <div class="n-main">
            <div class="n-left">
              <a class="n-logo" :href="url.domain">
                <img :src="require('./img/img_kbidm@2x.png')" alt="造物云"
              /></a>
              <div class="ul">
                <ul>
                  <li
                    id="trackEvent_indexBtn"
                    class="icon-down"
                    @click="indexPage"
                  >
                    首页
                  </li>
                  <li
                    @mouseenter="enter(1)"
                    @mouseleave="leave"
                    class="icon-down"
                  >
                    IDM下单<span class=" fa fa-angle-down reg-d"></span>
                    <div v-if="tabIndex == 1" class="panel-main panel-item">
                      <div class="p-main">
                        <div class="p-order">
                          <h3>PCB+PCBA+BOM</h3>
                          <p>
                            一站式在线估价&下单，可视化交付体验，专业柔性制造系统及供应链，满足客户个性化多样化的研发、生产需求。
                          </p>
                          <a
                            :href="url.orderDomain + '/index/inquire'"
                            id="trackEvent_IDMGo"
                            class="p-btn"
                            >立即下单</a
                          >
                        </div>
                        <a
                          target="_blank"
                          :href="url.orderDomain + '/index/PCB'"
                          class="p-pcb idm-item"
                        >
                          <h3>PCB</h3>
                          <p>
                            高端特色PCB样板、快板；兼容少量多品种、中批量生产
                          </p>
                          <div class="list">
                            <ul>
                              <li>HDI板</li>
                              <li>高频板</li>
                              <li>高多层板</li>
                              <li>金属基板</li>
                              <li>刚挠结合板</li>
                              <li>厚铜电源板</li>
                            </ul>
                          </div>
                        </a>
                        <a
                          target="_blank"
                          :href="url.orderDomain + '/index/PCBA'"
                          class="p-pcba idm-item"
                        >
                          <h3>PCBA</h3>
                          <p>高精密、智能硬件模块装联 大批量装联服务</p>
                          <div class="list">
                            <ul>
                              <li>SMT表面贴膜</li>
                              <li>微组装</li>
                              <li>THT通插装</li>
                              <li>工业防护&可靠性测试</li>
                            </ul>
                          </div>
                        </a>
                        <a
                          target="_blank"
                          :href="url.orderDomain + '/index/BOM'"
                          class="p-bom idm-item"
                        >
                          <h3>BOM</h3>
                          <p>资深工程师全程服务、高品质BOM咨询服务</p>
                          <div class="list">
                            <ul>
                              <li>大数据+资深工程师配齐</li>
                              <li>BOM自动匹配+成本评估</li>
                              <li>研发、计划、成本核算服务</li>
                            </ul>
                          </div>
                        </a>
                      </div>
                    </div>
                  </li>
                  <li
                    @mouseenter="enter(2)"
                    @mouseleave="leave"
                    class="icon-down "
                  >
                    EDS设计研发<span class=" fa fa-angle-down reg-d"></span>
                    <div v-if="tabIndex == 2" class="E-panel panel-item">
                      <div class="E-main">
                        <div class="E-left E-the">
                          <a target="_blank" :href="url.orderDomain + '/cad'">
                            <h3>高速PCB设计</h3>
                            <p>
                              以客户需求为导向，坚持系统化设计，帮助客户实现最优产品性能，提供可制造性、成本、制造周期等灵活增值服务。
                            </p>
                            <div class="E-list">
                              <ul>
                                <li>自动化估价+工程师跟进+规范化管理</li>
                                <li>聚焦通讯技术设备、工控主板等领域</li>
                                <li>全国近百名PCB设计工程师，保证交付可靠性</li>
                              </ul>
                            </div>
                          </a>
                        </div>
                        <div class="E-right E-the">
                          <a
                            target="_blank"
                            :href="url.domain + '/idm/view/projectNew.html'"
                          >
                            <h3>IDH产品研发服务</h3>
                            <p>
                              专注应用层研发、程序开发，提供多种成熟的设计与制造解决方案，从创意到制造一站式硬件创新服务。
                            </p>
                            <div class="E-list">
                              <ul>
                                <li>专注ARM、DSP、FPGA平台研发设计</li>
                                <li>一站式智能硬件平台开发</li>
                                <li>全程支持客户需求，从创意到量产</li>
                              </ul>
                            </div>
                          </a>
                        </div>
                      </div>
                    </div>
                  </li>
                  <li
                    @mouseenter="enter(3)"
                    @mouseleave="leave"
                    class="icon-down "
                  >
                    EES电子工程<span class=" fa fa-angle-down reg-d"></span>
                    <div v-if="tabIndex == 3" class="EES-panel panel-item">
                      <div class="EES-main">
                        <div class="EES-left EES-item">
                          <h3>EES电子工程服务</h3>
                          <p>
                            先进的检测设备和资深专业的技术团队，提供产品研发服务、DFX设计、BOM工程服务、产品检测服务等全产品生命周期技术支持。
                          </p>
                          <a
                            :href="url.domain + '/idm/view/server.html'"
                            class="p-btn"
                            >查看详情</a
                          >
                        </div>
                        <div class="EES-right EES-item">
                          <div class="E-item-l E-item">
                            <img :src="require('./img/icon_desigen.png')" />
                            <h3>设计服务</h3>
                            <p>SCH设计、PCB设计、结构设计、逆向设计、BOM服务</p>
                          </div>
                          <div class="E-item-r E-item">
                            <img :src="require('./img/icon_detection.png')" />
                            <h3>检测服务</h3>
                            <p>
                              器件失效模式分析、零件二次筛选测试、PCB失效模式分析、PCBA失效模式分析、产品环境测
                            </p>
                          </div>
                        </div>
                      </div>
                    </div>
                  </li>
                  <li
                    @mouseenter="enter(4)"
                    @mouseleave="leave"
                    class="icon-down "
                  >
                    生产与制造<span class=" fa fa-angle-down reg-d"></span>
                    <div v-if="tabIndex == 4" class="pro-panel panel-item">
                      <div class="pro-main">
                        <div class="pro-left">
                          <div
                            :class="['tab', tabFlag == 1 ? 'active' : '']"
                            @mouseover="tab(1)"
                          >
                            PCB生产制造
                          </div>
                          <div
                            :class="['tab', tabFlag == 2 ? 'active' : '']"
                            @mouseover="tab(2)"
                          >
                            PCBA装联
                          </div>
                          <div
                            :class="['tab', tabFlag == 3 ? 'active' : '']"
                            @mouseover="tab(3)"
                          >
                            BOM配齐
                          </div>
                        </div>
                        <div class="pro-right">
                          <div v-if="tabFlag == 1" class="content tab-c">
                            <div class="r-main">
                              <a
                                :href="
                                  url.domain +
                                    '/idm/view/pcbCraftSecondary.html?type=1'
                                "
                                target="_blank"
                                class="item"
                              >
                                <img
                                  :src="require('./img/product_img_1.png')"
                                  alt="HDI板"
                                />
                                <div class="text">
                                  <p>HDI板</p>
                                  <span>8层 FR4 S1000-2 4.0mm</span>
                                </div>
                              </a>
                              <a
                                :href="
                                  url.domain +
                                    '/idm/view/pcbCraftSecondary.html?type=2'
                                "
                                target="_blank"
                                class="item"
                              >
                                <img
                                  :src="require('./img/product_img_2.png')"
                                  alt="高多层板"
                                />
                                <div class="text">
                                  <p>高多层板</p>
                                  <span>8层 FR4 S1000-2 4.0mm</span>
                                </div>
                              </a>
                              <a
                                :href="
                                  url.domain +
                                    '/idm/view/pcbCraftSecondary.html?type=4'
                                "
                                target="_blank"
                                class="item"
                              >
                                <img
                                  :src="require('./img/product_img_3.png')"
                                  alt="高频板"
                                />
                                <div class="text">
                                  <p>高频板</p>
                                  <span>8层 FR4 S1000-2 4.0mm</span>
                                </div>
                              </a>
                              <a
                                :href="
                                  url.domain +
                                    '/idm/view/pcbCraftSecondary.html?type=6'
                                "
                                target="_blank"
                                class="item"
                              >
                                <img
                                  :src="require('./img/product_img_4.png')"
                                  alt="金属基板"
                                />
                                <div class="text">
                                  <p>金属基板</p>
                                  <span>8层 4.0mm</span>
                                </div>
                              </a>
                              <a
                                :href="
                                  url.domain +
                                    '/idm/view/pcbCraftSecondary.html?type=5'
                                "
                                target="_blank"
                                class="item"
                              >
                                <img
                                  :src="require('./img/product_img_5.png')"
                                  alt="厚铜电源板"
                                />
                                <div class="text">
                                  <p>厚铜电源板</p>
                                  <span>8层 4.0mm</span>
                                </div>
                              </a>
                              <a
                                :href="
                                  url.domain +
                                    '/idm/view/pcbCraftSecondary.html?type=3'
                                "
                                target="_blank"
                                class="item"
                              >
                                <img
                                  :src="require('./img/product_img_6.png')"
                                  alt="刚挠结合板"
                                />
                                <div class="text">
                                  <p>刚挠结合板</p>
                                  <span>8层 4.0mm</span>
                                </div>
                              </a>
                            </div>
                            <div class="r-more">
                              <a
                                :href="url.domain + '/idm/view/pcbCraft.html'"
                                id="trackEvent_PCB_More"
                                class="a-more"
                                >了解更多</a
                              >
                              <a
                                :href="url.orderDomain + '/index/PCB'"
                                id="trackEvent_PCB_Go"
                                class="btn-more"
                                >马上下单</a
                              >
                            </div>
                          </div>
                          <div v-if="tabFlag == 2" class="content tab-c">
                            <div class="r-main">
                              <div class="item-A">
                                <img :src="require('./img/icon_smt.png')" />
                                <h3>SMT表面贴膜</h3>
                                <p>
                                  Surface Mounted<br />
                                  Technology
                                </p>
                              </div>
                              <div class="item-A">
                                <img :src="require('./img/icon_tht.png')" />
                                <h3>THT通插装</h3>
                                <p>
                                  Through Hole <br />
                                  Technology
                                </p>
                              </div>
                              <div class="item-A">
                                <img
                                  :src="require('./img/icon_assembly.png')"
                                />
                                <h3>微组装</h3>
                                <p>
                                  Microassembly <br />
                                  process
                                </p>
                              </div>
                              <div class="item-A">
                                <img
                                  :src="require('./img/icon_protective.png')"
                                />
                                <h3>工业防护&可靠性测试</h3>
                                <p>
                                  Industrial protection & <br />
                                  reliability testing
                                </p>
                              </div>
                            </div>
                            <div class="r-more">
                              <a
                                :href="url.domain + '/idm/view/pcbACraft.html'"
                                id="trackEvent_PCBA_More"
                                class="a-more"
                                >了解更多</a
                              >
                              <a
                                :href="url.orderDomain + '/index/PCBA'"
                                id="trackEvent_PCBA_Go"
                                class="btn-more"
                                >马上下单</a
                              >
                            </div>
                          </div>
                          <div v-if="tabFlag == 3" class="content tab-c">
                            <div class="r-main">
                              <div class="item-B item-A">
                                <img :src="require('./img/icon_data.png')" />
                                <h3>大数据+资深工程师配齐</h3>
                                <div class="list-B">
                                  <ul>
                                    <li>高效自动匹配</li>
                                    <li>自研物料库</li>
                                    <li>优质原厂数据</li>
                                  </ul>
                                </div>
                              </div>
                              <div class="item-B item-A">
                                <img :src="require('./img/icon_bom.png')" />
                                <h3>BOM自动匹配+成本预估</h3>
                                <div class="list-B">
                                  <ul>
                                    <li>现货采购</li>
                                    <li>工程师配齐</li>
                                  </ul>
                                </div>
                              </div>
                              <div class="item-B item-A">
                                <img
                                  :src="require('./img/icon_development.png')"
                                />
                                <h3>研发、计划、成本核算服务</h3>
                                <div class="list-B">
                                  <ul>
                                    <li>系统自动匹配</li>
                                    <li>精准数据对接</li>
                                    <li>成本管理</li>
                                  </ul>
                                </div>
                              </div>
                            </div>

                            <div class="r-more">
                              <a
                                :href="url.domain + '/idm/view/pcbCraft.html'"
                                id="trackEvent_BOM_More"
                                class="a-more"
                                >了解更多</a
                              >
                              <a
                                :href="url.orderDomain + '/index/BOM'"
                                id="trackEvent_BOM_Go"
                                class="btn-more"
                                >马上下单</a
                              >
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </li>
                  <li
                    @mouseenter="enter(6)"
                    @mouseleave="leave"
                    class="icon-down "
                  >
                    解决方案<span class=" fa fa-angle-down reg-d"></span>
                    <div v-if="tabIndex == 6" class="pro-panel panel-item">
                      <div class="pro-main">
                        <div class="solve-left">
                          <h3 class="h3-text">行业解决方案</h3>
                          <p class="detail-text">
                            造物云面向不同行业和领域
                            的业务场景，提供从创意到产
                            品，生产到制造全链条硬件研
                            发解决方案，助力客户增效降 本，快速实现市场价值。
                          </p>
                        </div>
                        <div class="solve-right">
                          <div class="content">
                            <div
                              v-for="(item, index) in solveList"
                              :key="index"
                            >
                              <a :href="`${url.domain}${item.url}`">
                                <div class="solve-item">
                                  <div class="item-title">{{ item.h2 }}</div>
                                  <p class="item-content">{{ item.text }}</p>
                                </div>
                              </a>
                            </div>
                            <!-- <div class="solve-item">
                              <div class="item-title">通讯</div>
                              <p class="item-content">
                                新一代信息技术与通讯行业融合发展
                              </p>
                            </div>
                            <div class="solve-item">
                              <div class="item-title">智能硬件</div>
                              <p class="item-content">
                                驱动细分垂直市场，创造丰富应用场景
                              </p>
                            </div>
                            <div class="solve-item">
                              <div class="item-title">医疗</div>
                              <p class="item-content">
                                助力医疗安全，提升就医体验和可靠性
                              </p>
                            </div>
                            <div class="solve-item">
                              <div class="item-title">汽车</div>
                              <p class="item-content">
                                打造人车出行安全，驱动行业快速发展
                              </p>
                            </div>
                            <div class="solve-item">
                              <div class="item-title">工控</div>
                              <p class="item-content">
                                支撑工业转型升级，实现高质发展
                              </p>
                            </div>
                            <div class="solve-item">
                              <div class="item-title">农牧</div>
                              <p class="item-content">
                                实现农牧与自然和谐发展，提高工作效率
                              </p>
                            </div>
                            <div class="solve-item">
                              <div class="item-title">物联网</div>
                              <p class="item-content">
                                发挥物联网优势，领先技术助力行业升级
                              </p>
                            </div>
                            <div class="solve-item">
                              <div class="item-title">新能源</div>
                              <p class="item-content">
                                构建能源生态化应用，通过产品高效协同
                              </p>
                            </div> -->
                          </div>
                        </div>
                      </div>
                    </div>
                  </li>
                  <li
                    @mouseenter="enter(5)"
                    @mouseleave="leave"
                    class="icon-down "
                  >
                    了解造物<span class=" fa fa-angle-down reg-d"></span>
                    <div v-if="tabIndex == 5" class="u-panel panel-item">
                      <div class="u-main">
                        <div class="u-left">
                          <h3>关于造物云</h3>
                          <p>
                            基于数字化转型+互联网服务场景，为客户提供从硬件研发到制造的全流程服务。涵盖方案设计、高端印制线路板设计与制造、电子工程、电子装联、BOM服务、检测认证等一站式多元化服务。
                          </p>
                          <a
                            :href="url.domain + '/idm/view/aboutUs.html'"
                            id="trackEvent_Look_More"
                            class="u-btn"
                            >了解更多</a
                          >
                        </div>
                        <div class="u-right">
                          <div class="u-item">
                            <h3>数字化、信息化平台</h3>
                            <p>
                              创新服务模式，从估价、投产、生产进度等全流程信息化支持。
                            </p>
                          </div>
                          <div class="u-item">
                            <h3>一站式服务</h3>
                            <p>
                              从产品设计到生产制造的全生命周期，研产销一体化。
                            </p>
                          </div>
                          <div class="u-item">
                            <h3>产业资源协同</h3>
                            <p>
                              联结产业上下游资源，基于产品服务+科创+产学研，构建全链路化服务。
                            </p>
                          </div>
                        </div>
                      </div>
                    </div>
                  </li>
                </ul>
              </div>
            </div>
            <div class="n-right">
              <div class="loginB" v-if="!userInfo">
                <!-- <a id='trackEvent_reg' class="reg-btn" :href="url.domain + '/login/register'" >注册</a> -->
                <a
                  id="trackEvent_Login"
                  class="login-btn"
                  :href="url.domain + '/login/index'"
                  >注册 / 登陆</a
                >
              </div>
              <div
                class="info-n"
                v-if="userInfo"
                :id="[userInfo ? 'headerUserInfo' : 'headerUserInfoNone']"
              >
                <div class="shopCart">
                  <img :src="require('./img/cart.png')" />
                  <a :href="url.domain + '/idm/view/shoppingCar.html'"
                    >购物车</a
                  >
                </div>
                <div
                  class="info"
                  @mouseover="enterInfo"
                  @mouseleave="leaveInfo"
                >
                  <a class="name" href="javascript:void(0);">{{
                    userInfo.CustName
                  }}</a>
                  <div
                    class="info-item"
                    v-if="InfoShow"
                    v-loading="loginOutLoading"
                  >
                    <a :href="url.serverDomain + '/Home/Index'" class="item"
                      >个人中心</a
                    >
                    <a :href="url.orderDomain + '/bomlist'" class="item"
                      >KBOM列表</a
                    >
                    <a
                      href="javascript:void(0);"
                      class="item"
                      id="loginOut"
                      @click="loginOutHandle"
                      >退出登录</a
                    >
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div v-if="bjNavFlag" class="bj-nav"></div>
    </div>
  </div>
</template>

<script>
import * as util from "assets/js/util";
import { mapMutations, mapGetters, mapActions } from "vuex";
import { loginOut } from "api/login";
import { ERR_OK } from "api/config";
import cookies from "vue-cookie";

export default {
  props: {
    isFixed: false,
    bgColor: {
      type: String,
      default: ""
    }
  },
  data() {
    return {
      tabFlag: 1,
      bjNavFlag: false,
      loginOutLoading: false,
      InfoShow: false,
      //   userInfo: '',
      noticeType: false,
      noticeWindow: false,
      tabIndex: -1,

      config: util.config,
      typeindex: 1,
      isactive: {},
      solveList: [
        {
          url: "/idm/view/electricPower.html",
          h2: "电力",
          text: "提供安全合规方案，赋能行业价值"
        },
        {
          url: "/idm/view/communication.html",
          h2: "通讯",
          text: "新一代信息技术与通讯行业融合发展"
        },
        {
          url: "/idm/view/smartHardware.html",
          h2: "智能硬件",
          text: "驱动细分垂直市场，创造丰富应用场景"
        },

        {
          url: "/idm/view/medicalTreatment.html",
          h2: "医疗",
          text: "助力医疗安全，提升就医体验和可靠性"
        },
        {
          url: "/idm/view/automobile.html",
          h2: "汽车",
          text: "打造人车出行安全，驱动行业快速发展"
        },
        {
          url: "/idm/view/industrialControl.html",
          h2: "工控",
          text: "支撑工业转型升级，实现高质发展"
        },
        {
          url: "/idm/view/Farming.html",
          h2: "农牧",
          text: "实现农牧与自然和谐发展，提高工作效率"
        },
        {
          url: "/idm/view/InternetOfThings.html",
          h2: "物联网",
          text: "发挥物联网优势，领先技术助力行业升级"
        },
        {
          url: "/idm/view/newEnergy.html",
          h2: "新能源",
          text: "构建能源生态化应用，通过产品高效协同"
        }
      ]
    };
  },
  created() {
    this.rediUrl = encodeURIComponent(window.location.href);
    this.nowTime();
  },
  computed: {
    url() {
      return util.config;
    },
    onRoutes() {
      if (this.$route.matched.length < 1) {
        return this.$route.path;
        // return window.location.href;
      }
      let url = window.location.href;
      if (url.indexOf("?") != -1) {
        url = url.split("?")[0];
        return url;
      } else {
        return url;
      }
    },
    ...mapGetters(["authorToken", "userInfo"])
  },
  mounted() {
    var value = cookies.get("noticeStatus");
    if (value) {
      this.noticeWindow = false;
      this.noticeType = false;
    }
  },
  methods: {
    // 跳转
    hrefUrl() {
      window.location.href =
        "https://mp.weixin.qq.com/s/ITtaDUYEHWOfs4blElc5TQ";
    },
    // 跳转首页
    indexPage() {
      console.log("跳转hahhah");
      window.location.href = util.config.domain;
    },
    // 个人信息
    enterInfo() {
      // console.log('chuf?11111111111111')
      this.InfoShow = true;
    },
    leaveInfo() {
      // console.log('chuf?12121212')
      this.InfoShow = false;
    },
    // 生产与制造
    tab(index) {
      this.tabFlag = index;
    },
    enter(index) {
      console.log("触发");
      this.tabIndex = index;
      this.bjNavFlag = true;
    },
    leave() {
      this.tabIndex = -1;
      this.bjNavFlag = false;
    },
    // 时间
    nowTime() {
      var now = new Date();
      var nowYear = now.getFullYear();
      var nowMonth = now.getMonth() + 1;
      var nowDay = now.getDate();
      // console.log("年",nowYear,"月",nowMonth,"日",nowDay)
      const nowD = new Date();
      const endD = new Date("2022-10-08:00:00");
      const nowDTime = nowD.getTime();
      const endDTime = endD.getTime();
      if (nowDTime < endDTime) {
        this.noticeType = true;
        this.$emit("noticeType", true);
      } else {
        this.noticeType = false;
        this.$emit("noticeType", false);
      }
      // if (nowYear >= 2022) {
      //   if ((nowMonth == 4 && nowDay <= 30) || (nowMonth == 5 && nowDay <= 4)) {
      //     this.noticeType = true;
      //     this.$emit("noticeType", true);
      //   } else {
      //     this.noticeType = false;
      //     this.$emit("noticeType", false);
      //   }
      // }
      //   if (nowYear >= 2021 && nowMonth >= 10 && nowDay >= 7) {
      //     this.noticeType = false;
      //   }
    },
    closeWindow() {
      this.noticeWindow = false;
      cookies.set("noticeStatus", "is", { domain: ".eeidm.com" });
    },
    closeNotice() {
      this.noticeType = false;
      this.$emit("noticeType", false);
      cookies.set("noticeStatus", "is", { domain: ".eeidm.com" });
    },
    lookWindow() {
      this.noticeWindow = true;
      // cookies.delete('noticeStatus', { domain: util.config.cookieDomain })
    },
    changetype(val) {
      sessionStorage.setItem("typeIndex", val);
      this.nextTick(() => {});
    },
    loginOutHandle() {
      this.loginOutLoading = true;
      this._loginOut()
        .then(res => {
          if (res.code) {
            if (res.code != ERR_OK) {
              return Promise.reject(res);
            }
            this.signOut();
          }
        })
        .catch(erro => {
          console.log(erro);
          if (!erro.isCancel) {
            this.$message.error(erro.message);
          }
        })
        .finally(() => {
          this.loginOutLoading = false;
        });
    },
    _loginOut() {
      var param = {
        UID: this.userInfo.UserId,
        UserCode: this.userInfo.UserCode,
        UserName: this.userInfo.CustName
      };
      return loginOut(param);
    },
    ...mapMutations({
      UpdateAuthorization: "UPDATE_AUTHORTOKEN"
    }),
    ...mapActions(["updateUserInfo", "signOut"])
  },
  components: {}
};
</script>

<style lang="scss" rel="stylesheet/scss">
@import "~assets/scss/compile";
@import "./newNav";
</style>



// WEBPACK FOOTER //
// src/components/common/nav/newNav.vue